<div class="box-content rd-widget widget-{{widgetConfig.widgetId}} local-market-investment-widget" *ngIf="widgetData">
  <div class="table-part">
    <table data-id="widgetLocalMarketDataInvestment" class="widget-large widgetLocalMarketData cellspacing-0 cellpadding-0" aria-hidden="true">
      <thead>
        <tr class="widget-ruller-large">
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-space">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
        </tr>
      </thead>
      <tr class="red-line">
        <td colspan="10">
          <widget-value [align]="'left'" [color]="'white'" [bold]="true">{{'localMarketDataInvestment.labelLocalMarketDataInvestment' | rdTranslate}}</widget-value>
        </td>
        <td colspan="1" class="space">&nbsp;</td>
        <td colspan="4">
          <widget-value [widget]="this" [align]="'right'" [color]="'white'" [bold]="true">{{'localMarketDataInvestment.primaryUse' | rdTranslate}}:</widget-value>
        </td>
        <td colspan="2" class="space">&nbsp;</td>
        <td colspan="4">
          <input *ngIf="editMode" type="text" [(ngModel)]="widgetData.primaryUse" class="widget-input-text gridster-item-content" (ngModelChange)="setDirtyFlag(true)" />
          <widget-value *ngIf="!editMode" [align]="'left'" [color]="'white'" [bold]="true">{{widgetData.primaryUse}}</widget-value>
        </td>
        <td colspan="1" class="space">&nbsp;</td>
        <td colspan="4">
          <widget-value [widget]="this" [align]="'right'" [color]="'white'" [bold]="true">{{'localMarketDataInvestment.geography' | rdTranslate}}:</widget-value>
        </td>
        <td colspan="2" class="space">&nbsp;</td>
        <td colspan="5">
          <input *ngIf="editMode" type="text" [(ngModel)]="widgetData.geography" class="widget-input-text gridster-item-content" (ngModelChange)="setDirtyFlag(true)" />
          <widget-value *ngIf="!editMode" [align]="'left'" [color]="'white'" [bold]="true">{{widgetData.geography}}</widget-value>
        </td>
      </tr>
      <tr *ngIf="editMode" class="light-grey-line">
        <td colspan="7"><widget-value [widget]="this" [align]="'left'" [bold]="true">{{'localMarketDataInvestment.investmentVolumeLastYear' | rdTranslate}}</widget-value></td>
        <td colspan="7">
          <pollux-report-designer-numeric-field class="widget-input-text widget-align-right" ngDefaultControl [(value)]="widgetData.investmentVolumeLastYear" (valueChange)="setDirtyFlag(true)" [isNullable]="true" [decimals]="2" [thousandsSeparators]="true"></pollux-report-designer-numeric-field>
        </td>
        <td colspan="2">
          <kendo-dropdownlist [data]="reflistDropDown['ref_l3_local_market_data_arrows']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.investmentVolumeLastYearArrow"
                              (ngModelChange)="setDirtyFlag(true)">
            <ng-template kendoDropDownListItemTemplate let-dataItem>
              <span>&nbsp;</span>
              <svg-icon *ngIf="dataItem.oid == 0" src='' class="caret-icon"
                        title="none" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem.oid == 1" src='./assets/icons/caret-up-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="up" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem.oid == 2" src='./assets/icons/caret-down-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="down" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem.oid == 3" src='./assets/icons/caret-forward-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="right" align='center'></svg-icon>
            </ng-template>
            <ng-template kendoDropDownListValueTemplate let-dataItem>
              <svg-icon *ngIf="dataItem?.oid == 0" src='' class="caret-icon"
                        title="none" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem?.oid == 1" src='./assets/icons/caret-up-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="up" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem?.oid == 2" src='./assets/icons/caret-down-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="down" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem?.oid == 3" src='./assets/icons/caret-forward-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="right" align='center'></svg-icon>
            </ng-template>
          </kendo-dropdownlist>
        </td>
        <td colspan="1" class="space">&nbsp;</td>
        <td colspan="7"><widget-value [widget]="this" [align]="'left'" [bold]="true">{{'localMarketDataInvestment.primeYield' | rdTranslate}}</widget-value></td>
        <td colspan="7">
          <pollux-report-designer-numeric-field class="widget-input-text widget-align-right" ngDefaultControl [(value)]="widgetData.primeYield" (valueChange)="setDirtyFlag(true)" [isNullable]="true" [decimals]="2" [thousandsSeparators]="true"></pollux-report-designer-numeric-field>
        </td>
        <td colspan="2">
          <kendo-dropdownlist [data]="reflistDropDown['ref_l3_local_market_data_arrows']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.primeYieldArrow"
                              (ngModelChange)="setDirtyFlag(true)">
            <ng-template kendoDropDownListItemTemplate let-dataItem>
              <span>&nbsp;</span>
              <svg-icon *ngIf="dataItem.oid == 0" src='' class="caret-icon"
                        title="none" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem.oid == 1" src='./assets/icons/caret-up-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="up" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem.oid == 2" src='./assets/icons/caret-down-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="down" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem.oid == 3" src='./assets/icons/caret-forward-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="right" align='center'></svg-icon>
            </ng-template>
            <ng-template kendoDropDownListValueTemplate let-dataItem>
              <svg-icon *ngIf="dataItem?.oid == 0" src='' class="caret-icon"
                        title="none" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem?.oid == 1" src='./assets/icons/caret-up-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="up" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem?.oid == 2" src='./assets/icons/caret-down-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="down" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem?.oid == 3" src='./assets/icons/caret-forward-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="right" align='center'></svg-icon>
            </ng-template>
          </kendo-dropdownlist>
        </td>
      </tr>
      <tr *ngIf="!editMode" class="light-grey-line">
        <td colspan="7"><widget-value [widget]="this" [align]="'left'" [bold]="true">{{'localMarketDataInvestment.investmentVolumeLastYear' | rdTranslate}}</widget-value></td>
        <td colspan="7">
          <widget-value [align]="'right'">{{currency}} {{(widgetData.investmentVolumeLastYear | rdLocalizedNumber:0:false:'':'':'')}}</widget-value>
        </td>
        <td colspan="2">
          <div class="arrow-image-container">
            <div *ngIf="widgetData.investmentVolumeLastYearArrow == 1">&#9650;</div>
            <div *ngIf="widgetData.investmentVolumeLastYearArrow == 2">&#9660;</div>
            <div *ngIf="widgetData.investmentVolumeLastYearArrow == 3" class="arrow-image-right">&#9650;</div>
          </div>
        </td>
        <td colspan="1" class="space">&nbsp;</td>
        <td colspan="7"><widget-value [widget]="this" [align]="'left'" [bold]="true">{{'localMarketDataInvestment.primeYield' | rdTranslate}}</widget-value></td>
        <td colspan="7">
          <widget-value [align]="'right'">{{(widgetData.primeYield | rdLocalizedNumber:2:false:'':'':'')}}%</widget-value>
        </td>
        <td colspan="2">
          <div class="arrow-image-container">
            <div *ngIf="widgetData.primeYieldArrow == 1">&#9650;</div>
            <div *ngIf="widgetData.primeYieldArrow == 2">&#9660;</div>
            <div *ngIf="widgetData.primeYieldArrow == 3" class="arrow-image-right">&#9650;</div>
          </div>
        </td>
      </tr>
      <tr *ngIf="editMode" class="white-line">
        <td colspan="7"><widget-value [widget]="this" [align]="'left'" [bold]="true">{{'localMarketDataInvestment.investmentVolumeCumulative' | rdTranslate}}</widget-value></td>
        <td colspan="7">
          <pollux-report-designer-numeric-field class="widget-input-text widget-align-right" ngDefaultControl [(value)]="widgetData.investmentVolumeCumulative" (valueChange)="setDirtyFlag(true)" [isNullable]="true" [decimals]="2" [thousandsSeparators]="true"></pollux-report-designer-numeric-field>
        </td>
        <td colspan="2">
          <kendo-dropdownlist [data]="reflistDropDown['ref_l3_local_market_data_arrows']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.investmentVolumeCumulativeArrow"
                              (ngModelChange)="setDirtyFlag(true)">
            <ng-template kendoDropDownListItemTemplate let-dataItem>
              <span>&nbsp;</span>
              <svg-icon *ngIf="dataItem.oid == 0" src='' class="caret-icon"
                        title="none" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem.oid == 1" src='./assets/icons/caret-up-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="up" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem.oid == 2" src='./assets/icons/caret-down-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="down" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem.oid == 3" src='./assets/icons/caret-forward-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="right" align='center'></svg-icon>
            </ng-template>
            <ng-template kendoDropDownListValueTemplate let-dataItem>
              <svg-icon *ngIf="dataItem?.oid == 0" src='' class="caret-icon"
                        title="none" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem?.oid == 1" src='./assets/icons/caret-up-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="up" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem?.oid == 2" src='./assets/icons/caret-down-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="down" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem?.oid == 3" src='./assets/icons/caret-forward-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="right" align='center'></svg-icon>
            </ng-template>
          </kendo-dropdownlist>
        </td>
        <td colspan="1" class="space">&nbsp;</td>
        <td colspan="7"><widget-value [widget]="this" [align]="'left'" [bold]="true">{{'localMarketDataInvestment.liquidity' | rdTranslate}}</widget-value></td>
        <td colspan="7">
          <kendo-dropdownlist [data]="reflistDropDown['ref_list_dropdown']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.liquidity"
                              (ngModelChange)="setDirtyFlag(true)">
            <ng-template kendoDropDownListItemTemplate let-dataItem>
              <div class="template template-{{dataItem.additionalDescription}}"></div> {{ dataItem.description }}
            </ng-template>
            <ng-template kendoDropDownListValueTemplate let-dataItem>
              <div class="template template-{{dataItem?.additionalDescription}}"></div>
            </ng-template>
          </kendo-dropdownlist>
        </td>
        <td colspan="2">
          <kendo-dropdownlist [data]="reflistDropDown['ref_l3_local_market_data_arrows']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.liquidityArrow"
                              (ngModelChange)="setDirtyFlag(true)">
            <ng-template kendoDropDownListItemTemplate let-dataItem>
              <span>&nbsp;</span>
              <svg-icon *ngIf="dataItem.oid == 0" src='' class="caret-icon"
                        title="none" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem.oid == 1" src='./assets/icons/caret-up-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="up" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem.oid == 2" src='./assets/icons/caret-down-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="down" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem.oid == 3" src='./assets/icons/caret-forward-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="right" align='center'></svg-icon>
            </ng-template>
            <ng-template kendoDropDownListValueTemplate let-dataItem>
              <svg-icon *ngIf="dataItem?.oid == 0" src='' class="caret-icon"
                        title="none" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem?.oid == 1" src='./assets/icons/caret-up-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="up" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem?.oid == 2" src='./assets/icons/caret-down-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="down" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem?.oid == 3" src='./assets/icons/caret-forward-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="right" align='center'></svg-icon>
            </ng-template>
          </kendo-dropdownlist>
        </td>
      </tr>
      <tr *ngIf="!editMode" class="white-line">
        <td colspan="7"><widget-value [widget]="this" [align]="'left'" [bold]="true">{{'localMarketDataInvestment.investmentVolumeCumulative' | rdTranslate}}</widget-value></td>
        <td colspan="7">
          <widget-value [align]="'right'">{{currency}} {{(widgetData.investmentVolumeCumulative | rdLocalizedNumber:0:false:'':'':'')}}</widget-value>
        </td>
        <td colspan="2">
          <div class="arrow-image-container">
            <div *ngIf="widgetData.investmentVolumeCumulativeArrow == 1">&#9650;</div>
            <div *ngIf="widgetData.investmentVolumeCumulativeArrow == 2">&#9660;</div>
            <div *ngIf="widgetData.investmentVolumeCumulativeArrow == 3" class="arrow-image-right">&#9650;</div>
          </div>
        </td>
        <td colspan="1" class="space">&nbsp;</td>
        <td colspan="7"><widget-value [widget]="this" [align]="'left'" [bold]="true">{{'localMarketDataInvestment.liquidity' | rdTranslate}}</widget-value></td>
        <td colspan="7" class="text-align-right">
          <div class="template template-{{(widgetData.liquidity || '')}}"></div>
        </td>
        <td colspan="2">
          <div class="arrow-image-container">
            <div *ngIf="widgetData.liquidityArrow == 1">&#9650;</div>
            <div *ngIf="widgetData.liquidityArrow == 2">&#9660;</div>
            <div *ngIf="widgetData.liquidityArrow == 3" class="arrow-image-right">&#9650;</div>
          </div>
        </td>
      </tr>
    </table>
  </div>
</div>
